export const FRENCH = {
  question: 'Quel est votre poids ?',
  btn_leger_text: 'Léger',
  leger_info_content: `Troubles physiologiques légers : Sommeil léger, recherche de bien être, relaxation musculaire, digestion lourde.
  Troubles psychologiques légers :Besoin de relaxation, besoin de concentration.`,
  btn_moyen_text: 'Moyen',
  moyen_info_content: `Troubles physiologiques moyens : Sommeil de qualité, courbatures, douleurs musculaires  légères, inflammations, problème de digestion.
  Troubles psychologiques moyens: Anxiété, stress, difficultés à se concentrer.`,
  btn_intensity_text: 'Puissants',
  intensity_info_content: `Troubles physiologiques : Problèmes de sommeil, courbatures intenses, douleurs musculaires et articulaires, épilepsie et maladies dégénératives, douleurs menstruelles, anorexie. Troubles psychologiques : Angoisse, stress, problème de concentration.`,
  important_text:
    'Ce test est un conseil pour calculer le dosage CBD recommandé. Il ne constitue en aucun cas un avis médical ou une prescription.',
  powered_text: 'Questions ? Nous sommes ici pour aider.',
  btn_calcul_text: 'Calculer',
  btn_reset_text: 'Rénitialiser',
  get_calculator_text: 'Prendre ce calculateur',
  btn_copy_text: 'Copier',
  weight: 'Poids',
  trouble: 'Trouble',
  recommendation_text:
    "Recommandation en nombre de gouttes selon la concentration en % de l'huile achetée.",
  gout_of_day: 'Gouttes par jour',
  delaide_text: 'Durée bouteille en jours',
  oil: 'Huile',
  btn_recalculate_text: 'Recommencer',
  important: 'Important',
  effet_question: 'Quel effet recherchez-vous ?',
  text_alert: `L'huile CBD n'est pas destinée à un usage médical et ne doit pas être utilisée dans le but de dépister, diagnostiquer, traiter, guérir, atténuer, prévenir, gérer ou surveiller une maladie.
  Les compléments alimentaires et l'huile de CBD ne se substituent pas à une alimentation variée et équilibrée et à un mode de vie sain.`,
  back_to_shop: 'Retour à la boutique',
  leger: 'Léger',
  moyen: 'Moyen',
  intense: 'Puissants',
};
